module.exports = __webpack_public_path__ + "static/media/ourbg.1ce000ae.jpg";